import axios from 'axios'
import { CADASTRAR_EMISSAO_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarEmissaoMdfe(emissaoMdfe) {
  const url = `${URL}/emissao-mdfe`;
  return dispatch => axios.post(url, emissaoMdfe, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_EMISSAO_MDFE,
        payload: response
      })
  );
}
